module.exports = __webpack_public_path__ + "static/img/software2.9334adf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/software2.jpg
// module id = DBne
// module chunks = 1